export default __webpack_public_path__ + "static/international-metric-mobile-9564b521842e24b69f7d73db27959954.svg";